import { PdfPaginator } from "./PdfPaginator";
import type { ReportPdfModel } from "./reportTypes";

type PdfPagesProps = {
  model: ReportPdfModel;
};

/** Cover + dynamically packed content sections + closing */
export function PdfPages({ model }: PdfPagesProps) {
  return <PdfPaginator model={model} />;
}
